<template>
  <div
    class="standard-hover"
    :style="hoverStyle"
    >
    <slot/>
  </div>
</template>
<style scoped>
  .standard-hover {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0,0,0,0.5);
    border: solid 1px;
    border-radius: 3px !important;
  }
</style>
<script>
export default {
  props: ['border_color', 'border_style', 'easter_egg'],
  data: () => ({
  }),
  // updated(){
  //   console.log('Standardhover updated');
  // },
  computed: {
    hoverStyle() {
      let style = ""
      if (this.border_color) {
        style = `border-color: ${this.border_color};`
      }
      if (this.border_style) {
        style = style + ` border-style: ${this.border_style};`
      }
      if (this.easter_egg) {
        style = style + `background-color: rgba(0,0,0,0); border-style: none`
      }
      return style
    },
  }
}
</script>
